import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface CreateSheetDialogProps {
  open: boolean;
  name: string;
  saving: boolean;
  onNameChange: (name: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function CreateSheetDialog({
  open,
  name,
  saving,
  onNameChange,
  onConfirm,
  onCancel,
}: Readonly<CreateSheetDialogProps>) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>{t("calculations.methods.new-sheet-title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label={t("calculations.methods-input.name")}
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onConfirm();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={saving}>
          {t("generic.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={!name.trim() || saving}
          startIcon={saving ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          {t("generic.create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}